import { useCustomTheme } from '@/hooks/useCustomTheme';

export const useCheckResult = (passed: boolean | undefined) => {
  const { palette } = useCustomTheme();

  const getCheckResultParams = () => {
    switch (passed) {
      case true:
        return {
          textId: 'PASSED',
          iconName: 'check',
          color: palette.success.main,
          contrastText: palette.success.contrastText,
        };
      case false:
        return {
          textId: 'FAILED',
          iconName: 'close',
          color: palette.error.main,
          contrastText: palette.error.contrastText,
        };
      default:
        return {
          textId: 'PENDING',
          iconName: 'hourglass_empty',
          color: palette.grey[400],
          contrastText: palette.common.white,
        };
    }
  };

  const checkResultParams = getCheckResultParams();

  return { checkResultParams };
};
